<div class="forbidden">
  <h1>
    You are not authorized to view the requested page.
  </h1>
  <h2>
    Please select an alternative page from the side menu or search for a page in the <a
      routerLink="/view/page_list_view">All pages</a> view.
  </h2>
</div>
